import { Grid } from "@mui/material";

import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { FormAsyncPreDiningArrangement } from "../../../components/Forms/Arrangements/FormAsyncPreDiningArrangement";

function Arrangements() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Grid container spacing={1}>
        <Grid alignContent={"flex-start"} item xs={12}>
          <Card>
            <CardBody style={{ display: "flex", flexWrap: "wrap" }}>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper tKey={"Arrangements"} />
                </h3>
              </Grid>
              <FormAsyncPreDiningArrangement />
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default Arrangements;
